import calls from '@/backend/api-calls'


const state = () => ({
  productionSheets: [],
  finishingSteps: [],
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null
  }
})


const getters = {
  productionSheetIds: state => {
    return state.productionSheets.map(d => d.id);
  }
}


const actions = {
  getProductionSheets: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.productionSheets.get(parameters)
        .then(resp => {
          commit("setProductionSheets", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addProductionSheet({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.productionSheets.post(data, parameters)
        .then(resp => {
          commit("insertProductionSheet", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  uploadImage: ({commit}, { productionSheetId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productionSheet.attachImage(productionSheetId, data)
        .then(resp => {
          commit("insertUpdatedProductionSheet", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateProductionSheet: ({commit}, { productionSheetId, data }) => {
    return new Promise((resolve, reject) => {
      calls.productionSheet.put(productionSheetId, data).then(
        resp => {
          commit("insertUpdatedProductionSheet", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Production sheet successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteProductionSheet: ({commit}, productionSheetId) => {
    return new Promise((resolve, reject) => {
      calls.productionSheet.delete(productionSheetId).then(
        resp => {
          commit("removeProductionSheet", productionSheetId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Production sheet successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItem: ({commit}, item) => {
    return new Promise((resolve, reject) => {
      calls.productionSheetsItems.post(item).then(
        resp => {
          commit("insertItem", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.productionSheetIds);
    } else {
      commit("deselectAll");
    }
  },
  getFinishingSteps: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.finishingSteps.get(parameters)
        .then(resp => {
          commit("setFinishingSteps", resp.data.results);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addFinishingStep: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.finishingSteps.post(data)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Finish successfully added'
          }, { root: true });
          commit("insertFinishingStep", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteFinishingStep: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      calls.finishingStep.delete(id)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Finish successfully deleted'
          }, { root: true });
          commit("removeFinishingStep", id);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateFinishingStep: ({commit}, { finishingStepId, data}) => {
    return new Promise((resolve, reject) => {
      calls.finishingStep.put(finishingStepId, data)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Finish successfully updated'
          }, { root: true });
          commit("insertUpdatedFinishingStep", finishingStepId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}


const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setProductionSheets(state, data) {
    state.pagination = data.pagination;
    state.productionSheets = data.results;
  },
  insertProductionSheet(state, data) {
    state.productionSheets.push(data);
  },
  insertUpdatedProductionSheet(state, data) {
    state.productionSheets.forEach((productionSheet, i) => {
      if (productionSheet.id == data.id) {
        state.productionSheets.splice(i, 1, data);
      }
    })
  },
  removeProductionSheet(state, productionSheetId) {
    state.productionSheets.forEach((productionSheet, i) => {
      if (productionSheet.id == productionSheetId) {
        state.productionSheets.splice(i, 1);
      }
      const index = state.selected.indexOf(productionSheetId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  insertItem(state, item) {
    state.productionSheets.forEach(productionSheet => {
      if (productionSheet.id == item.production_sheet_id) {
        productionSheet.items.push(item);
      }
    })
  },
  selectAll(state, productionSheetIds) {
    state.allSelected = true;
    productionSheetIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  setFinishingSteps(state, data) {
    state.finishingSteps = data;
  },
  insertFinishingStep(state, data) {
    state.finishingSteps.push(data);
  },
  insertUpdatedFinishingStep(state, data) {
    state.finishingSteps.forEach((step, i) => {
      if (step.id == data.id) {
        state.finishingSteps.splice(i, 1, data);
      }
    })
  },
  removeFinishingStep(state, id) {
    state.finishingSteps.forEach((step, i) => {
      if (step.id == id) {
        state.finishingSteps.splice(i, 1);
      }
    })
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}